import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Table,
	Col,
} from "reactstrap";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../reports.scss";

import SLE_logo from "../../../assets/images/SriLalitha_Logo.png";
// import "../app-invoice.css";
import { getIGPDocReport } from "../../../store/Reports/actions";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

class IGPReportDocument extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getIGPDocReport(this.props.match.params.id);
	}
	// getPDFReport() {
	//   //	297 x 210 mm
	//   const codewidth = document.getElementById("toPdf").style.width;
	//   document.getElementById("toPdf").style.width = "297mm";
	//   const doc = new jsPDF("l", "mm", [297, 210]);
	//   doc.setDisplayMode(1);
	//   doc.html(document.getElementById("toPdf"), {
	//     callback: function (doc) {
	//       doc.save();
	//       document.getElementById("toPdf").style.width = codewidth;
	//     },
	//     x: 0,
	//     y: 0,
	//     html2canvas: { scale: 0.25 },
	//   });
	// }

	getPDFReport = async () => {
		const element = document.getElementById("toPdf");
		if (!element) return;

		const originalWidth = element.style.width;
		element.style.width = "297mm";
		element.style.maxWidth = "290mm";

		const pdf = new jsPDF("p", "mm", "a4");
		const pageWidth = pdf.internal.pageSize.getWidth();
		const pageHeight = pdf.internal.pageSize.getHeight();

		// Use a higher scale for better text clarity
		const canvas = await html2canvas(element, {
			scale: 2,
			useCORS: true,
			scrollX: 0,
			scrollY: 0,
			windowWidth: element.scrollWidth,
			windowHeight: element.scrollHeight,
		});

		const imgData = canvas.toDataURL("image/png");
		const imgWidth = pageWidth;
		const imgHeight = (canvas.height * imgWidth) / canvas.width;

		let heightLeft = imgHeight;
		let position = 0;

		pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
		heightLeft -= pageHeight;

		while (heightLeft > 0) {
			position -= pageHeight;
			pdf.addPage();
			pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
			heightLeft -= pageHeight;
		}

		pdf.save("In_Gate_Pass.pdf");

		// Revert back to original
		element.style.width = originalWidth;
	};
	reportBody() {
		return (
			<Row className="p-1 report-preview">
				<Col md={12} className="p-1">
					<Card className="p-1 report-preview-card">
						<CardBody className="report-padding pb-0">
							<div className="report-body flex-sm-row flex-column  mt-0">
								<div className=" ">
									<h5 className="card-title-16 pt-2 ">
										SRI LALITHA ENTERPRISES INDUSTRIES PVT.
										LTD
									</h5>
									<p className="card-title-14 pt-2 mb-0">
										Valuthimmapuram Road, PEDDAPURAM -
										533437, E.G. Dist. - AP
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Phone No.0884-2326661, 62, Mobile
										No.9494127893,
									</p>
									<p className="card-title-14 pt-2 mb-0">
										Email: purchase@sleipl.com,
										lalitharice@gmail.com
									</p>
									<p className="card-title-14 pt-2">
										GSTIN : 37AAKCS3233N1ZX
									</p>
								</div>
								<div className="pt-2">
									<span className="p-4">
										<img
											className="img-fluid p-0"
											src={SLE_logo}
											alt="Logo"
											width="100"
											height="120"
										/>
									</span>
									<h4 className="report-title mb-0">
										<span className="report-number">
											In Gate Pass
										</span>
									</h4>
									<h5 className="report-title">
										<span className="report-number">
											#{this.props.IGP_Doc_report.code}
										</span>
									</h5>
								</div>
							</div>
							<hr className="hr-black-color " />

							<div className="report-body flex-sm-row flex-column mt-0">
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Create By:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.IGP_Doc_report
													.createdby?.fullname
											}{" "}
											(
											{
												this.props.IGP_Doc_report
													.createdby?.username
											}
											)
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Submited On:
										</p>
										<p className="report-wrapper-det">
											{moment(
												this.props.IGP_Doc_report
													.createdon
											).format("DD-MM-YYYY")}
										</p>
									</div>
								</div>
								<div>
									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Person Name:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.IGP_Doc_report
													.personname
											}
										</p>
									</div>

									<div className="report-wrapper">
										<p className="report-wrapper-title">
											Vehicle No:
										</p>
										<p className="report-wrapper-det">
											{
												this.props.IGP_Doc_report
													.vehicleno
											}
										</p>
									</div>
								</div>
							</div>
							<hr className="hr-black-color " />
							<div className="table-responsive m-0">
								<Table
									// striped
									bordered
									// hover
									className="mb-0 p-0 table-centered table-color-black ">
									<thead className="bg-light text-center">
										<tr>
											<th className="">S.No</th>
											<th className="">PO Code</th>
											<th className="">Vendor Code</th>
											<th className="">Vendor</th>
											<th className="">Items Count</th>
											<th className="">Remarks</th>
											<th className="">PO Bill</th>
										</tr>
									</thead>
									<tbody>
										{this.props.IGP_Doc_report.grn2pos
											?.length !== 0 ? (
											<>
												{this.props.IGP_Doc_report?.grn2pos?.map(
													(item, key) => (
														<>
															<tr key={key}>
																<td className="nowrap text-center">
																	{key + 1}
																</td>
																<td className="nowrap text-center">
																	{
																		item.purchaseorder_code
																	}
																</td>
																<td className="nowrap text-center">
																	{
																		item
																			.vendor
																			.name
																	}
																</td>
																<td className="nowrap text-center">
																	{
																		item
																			.vendor
																			.code
																	}
																</td>
																<td className="nowrap text-center">
																	{
																		item.items_count
																	}
																</td>
																<td className="nowrap text-center">
																	{
																		item.description
																	}
																</td>
																<td className="nowrap text-center">
																	{item
																		.bill_image
																		?.file
																		? "Attached"
																		: "Not Attached"}
																</td>
															</tr>
														</>
													)
												)}
											</>
										) : (
											<tr>
												<td
													colSpan={9}
													className="text-center">
													<div>
														<span className="font-size-18 text-danger">
															Data not available
														</span>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</div>
							{/* <div className=" card-title-14 mt-2  mb-0">
                <p>Vendors List</p>
              </div> */}
							<hr className="hr-black-color " />
							<div className="table-responsive m-0">
								<Table
									// striped
									bordered
									// hover
									className="mb-0 p-0 table-centered table-color-black">
									<thead className="bg-light text-center">
										<tr>
											<th className="">S.No</th>
											<th className="">IGP ItemCode</th>
											<th className="">PO Code</th>
											<th className="">PO Item Code</th>
											<th className="">Item Image</th>
											<th className="">Items Name</th>
											<th className="">
												Received Quantity
											</th>
										</tr>
									</thead>
									<tbody>
										{this.props.IGP_Doc_report.grn2items
											?.length !== 0 ? (
											<>
												{this.props.IGP_Doc_report.grn2items?.map(
													(item, key) => (
														<>
															<tr key={key}>
																<td className="nowrap text-center">
																	{key + 1}
																</td>
																<td className="nowrap text-center">
																	{item.code}
																</td>
																<td className="nowrap text-center">
																	{
																		item.purchaseorder_code
																	}
																</td>
																<td className="nowrap text-center">
																	{
																		item.poitem_code
																	}
																</td>
																<td className="nowrap text-center">
																	<div className="product-detail text-center">
																		<img
																			src={
																				item
																					?.product
																					?.image ==
																				null
																					? DefaultImg
																					: item
																							?.product
																							?.image
																			}
																			alt="product-img"
																			title="product-img"
																			className="product-img  img-fluid mx-auto tab-img rounded"
																			style={{
																				height: "75px",
																				width: "100px",
																			}}
																		/>
																	</div>
																</td>
																<td className="nowrap ">
																	<h5 className="font-size-14 ">
																		{" "}
																		{
																			item
																				.product
																				.name
																		}
																	</h5>
																	{/* <p className="mb-0">
                                                      Make :{" "}
                                                      <span className="font-weight-medium">
                                                        {item.make}
                                                      </span>
                                                    </p> */}
																	{/* <p className="mb-0">
                                                    Description :{" "}
                                                    <span className="font-weight-medium">
                                                      {item.description}
                                                    </span>
                                                  </p> */}
																</td>
																<td className="nowrap text-center">
																	{item.qty}{" "}
																	{
																		item
																			.unit
																			.name
																	}
																</td>
															</tr>
														</>
													)
												)}
											</>
										) : (
											<tr>
												<td
													colSpan={9}
													className="text-center">
													<div>
														<span className="font-size-18 text-danger">
															Data not available
														</span>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</Table>
							</div>
							<hr className="hr-black-color " />
							<Row>
								<Col md={12}>
									<p className="font-weight-bold mb-1 text-black">
										Other Details:
									</p>
									<span className="ml-4 text-black">
										{this.props.IGP_Doc_report.description}
									</span>
								</Col>
							</Row>
							<hr className="hr-black-color " />
							<Row>
								<Col md={12}>
									<p className="font-weight-bold mb-1 text-black">
										Attachment:
									</p>
									<Row>
										{this.props.IGP_Doc_report
											?.vehicle_image && (
											<Col md={6}>
												<span className="ml-4 text-black">
													Vehicle Image
												</span>
												<div className="product-detail text-center">
													<img
														src={
															this.props
																.IGP_Doc_report
																?.vehicle_image
																?.file
														}
														alt="Vehicle"
														title="Vehicle Image"
														className="product-img  img-fluid mx-auto tab-img rounded"
													/>
												</div>
											</Col>
										)}
										{this.props.IGP_Doc_report
											?.user_image && (
											<Col md={6}>
												<span className="ml-4 text-black">
													Person Image
												</span>
												<div className="product-detail text-center">
													<img
														src={
															this.props
																.IGP_Doc_report
																?.user_image
																?.file
														}
														alt="Person "
														title="Person Image"
														className="product-img  img-fluid mx-auto tab-img rounded"
													/>
												</div>
											</Col>
										)}
									</Row>

									{/* <ol>
                    <li>
                      {this.props.IGP_Doc_report.vehicle_image && (
                        <Link
                          to="#"
                          onClick={this.props.IGP_Doc_report.vehicle_image.file}
                          className="right-bar-toggle"
                        >
                          <span className="ml-4 text-black">Vehicle Image</span>
                        </Link>
                      )}
                    </li>
                    <li>
                      {this.props.IGP_Doc_report.user_image && (
                        <Link
                          to="#"
                          onClick={this.props.IGP_Doc_report.user_image.file}
                          className="right-bar-toggle "
                        >
                          <span className="ml-4 text-black">Person Image</span>
                        </Link>
                      )}
                    </li>
                  </ol> */}
								</Col>
							</Row>

							<hr className="hr-black-color page-break " />
							<Row>
								<Col md={12}>
									<p className="font-weight-bold mb-1 text-black">
										PO Bill Images:
									</p>
									{this.props.IGP_Doc_report.attachment
										?.length !== 0 ? (
										<>
											{this.props.IGP_Doc_report.attachment?.map(
												(image, key) => (
													<>
														<div className="page-break" />
														<div className="text-center">
															<img
																src={image}
																alt="PO Bill "
																title="PO Bill Image"
																className="Igp-img  img-fluid mx-auto tab-img rounded"
																// style={{
																//   height: "100px",
																//   width: "150px",
																// }}
															/>
														</div>
														<br />
													</>
												)
											)}
										</>
									) : (
										<>
											<span className="ml-4 text-black">
												No attachments
											</span>
										</>
									)}
								</Col>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		);
	}
	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom no-print ">
										<Link
											to="#"
											onClick={() =>
												this.props.history.goBack()
											}
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										{/* {this.props.rfqPDF ? (
                      <Link
                        // to="/rfqdashboard"
                        onClick={() => this.props.history.goBack()}
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    ) : (
                      <Link
                        to="/rfqreport"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                    )} */}
										<div className="float-right">
											<div className="d-inline-block ">
												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() =>
														this.getPDFReport()
													}>
													<i className="ri-file-excel-2-line"></i>
													<span className="d-none d-inline-block ml-1">
														PDF
													</span>
												</Button>

												<Button
													type="button"
													outline
													color="secondary"
													className=" mr-2"
													onClick={() => {
														window.focus();
														window.print();
													}}>
													<i className="mdi  mdi-printer"></i>
													<span className="d-none d-inline-block ml-1">
														Print
													</span>
												</Button>
											</div>
										</div>
									</CardHeader>
									<CardBody
										className="pt-1 mr-auto mx-auto"
										id="toPdf"
										// style={{ width: "297mm" }}
									>
										{this.reportBody()}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { IGP_Doc_report, rfqPDF } = state.reports;
	return {
		IGP_Doc_report,
		rfqPDF,
	};
};

export default connect(mapStatetoProps, {
	getIGPDocReport,
})(IGPReportDocument);
